(() => {
const dialog = document.getElementById('AttiaAppDialog');
const install = document.querySelector('[data-attia-app-install]');
let promptEvent;
if (!dialog || !install) return;
document.querySelectorAll('[data-attia-app-open]').forEach(button => button.addEventListener('click', () => dialog.showModal()));
dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
window.addEventListener('beforeinstallprompt', event => { event.preventDefault(); promptEvent = event; install.hidden = false; });
install.addEventListener('click', async () => {
if (!promptEvent) return;
install.disabled = true;
try { await promptEvent.prompt(); await promptEvent.userChoice; } finally { promptEvent = null; install.hidden = true; install.disabled = false; }
});
window.addEventListener('appinstalled', () => { dialog.close(); promptEvent = null; install.hidden = true; document.querySelector('.attia-app-promo')?.remove(); });
document.querySelectorAll('.attia-app-nav a').forEach(link => { if (new URL(link.href).pathname === location.pathname) link.setAttribute('aria-current', 'page'); });
if (new URLSearchParams(location.search).get('attia-app') === 'install') dialog.showModal();
})();